// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for PayoutRequests.jsx (P0 — Admin payout approvals).
 * Loaded AFTER index.css so equal-specificity rules here win by source order.
 *
 * Breakpoints (single source of truth, matching CLAUDE.md):
 *   mobile  : <=576px
 *   tablet  : 577–991px
 *   laptop  : 992–1280px
 *   desktop : >=1281px
 *
 * Desktop appearance is intentionally unchanged. All overrides live inside
 * max-width media queries so they do not touch desktop rendering.
 */

/* ==========================================================================
   Tablet (<=991px): mild layout adjustments
   ========================================================================== */
@media (max-width: 991px) {
  /* Give the page breathing room when the left sidebar is off-canvas */
  .payout-requests-page {
    padding: 0;
  }

  /* Stats: 2-column grid on tablet */
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Right-side detail drawer: full width on tablet */
  .request-detail-drawer {
    width: 100%;
    max-width: 100%;
  }

  /* Toolbar: allow wrapping so sort button doesn't clip */
  .table-toolbar {
    flex-wrap: wrap;
  }
}

/* ==========================================================================
   Mobile (<=576px): full app-like treatment
   ========================================================================== */
@media (max-width: 576px) {
  /* ---- Page header ---- */
  .payout-requests-page .page-header {
    margin-bottom: 1rem;
  }

  .payout-requests-page .page-header h1 {
    font-size: 1.25rem;
  }

  /* ---- Gas tank banner ---- */
  .payout-requests-page .gas-tank-banner {
    font-size: 0.8rem;
    padding: 0.625rem 0.75rem;
    flex-wrap: wrap;
  }

  /* ---- Stats grid: single column ---- */
  .payout-requests-page .stats-grid {
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
  }

  .payout-requests-page .stat-card {
    padding: 1rem;
  }

  .payout-requests-page .stat-icon {
    width: 40px;
    height: 40px;
  }

  .payout-requests-page .stat-value {
    font-size: 1.25rem;
  }

  /* ---- Status tabs: horizontally scrollable so they don't wrap/overflow ---- */
  .payout-requests-page .status-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;        /* Firefox */
    flex-wrap: nowrap;
    padding-bottom: 0;
    gap: 0.25rem;
  }

  .payout-requests-page .status-tabs::-webkit-scrollbar {
    display: none;                /* Chrome/Safari */
  }

  .payout-requests-page .status-tab {
    padding: 0.75rem 0.875rem;
    min-height: 44px;
    flex-shrink: 0;
  }

  /* ---- Search + toolbar ---- */
  .payout-requests-page .table-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 0.625rem;
  }

  .payout-requests-page .search-box {
    max-width: none;              /* override the 400px desktop cap */
    width: 100%;
  }

  .payout-requests-page .search-box input {
    min-height: 44px;
    font-size: 1rem;              /* prevent iOS zoom on focus */
  }

  .payout-requests-page .toolbar-actions {
    justify-content: flex-end;
  }

  .payout-requests-page .btn-toolbar {
    min-height: 44px;
    padding: 0.625rem 1rem;
  }

  .payout-requests-page .btn-clear-filters {
    min-height: 44px;
    padding: 0.625rem 0.75rem;
  }

  /* ---- Table -> card view ---- */
  /*
   * The table is hidden and each <tr> is rendered as a card.
   * Card layout uses CSS to show label/value pairs by targeting data-label
   * attributes on <td> elements (added via JSX className approach below).
   * We instead use a card-per-row approach by hiding thead and making
   * each td a block with a pseudo-element label pulled from its class.
   */

  .payout-requests-page .payout-table-container {
    overflow-x: visible;          /* no horizontal scroll on mobile */
    border: none;
    background: transparent;
    padding: 0;
  }

  .payout-requests-page .payout-table {
    display: block;
    table-layout: auto;
    border-collapse: collapse;
  }

  .payout-requests-page .payout-table thead {
    display: none;                /* hide column headers; labels shown in CSS */
  }

  .payout-requests-page .payout-table tbody {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .payout-requests-page .payout-table tr {
    display: flex;
    flex-direction: column;
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    padding: 0.875rem 1rem;
    gap: 0.5rem;
    border-bottom: none;          /* override inline tr border-bottom */
  }

  .payout-requests-page .payout-table td {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0;
    font-size: 0.875rem;
    white-space: normal;
    word-break: break-word;
  }

  /* Label prefix rendered via ::before using data-label attribute.
     JSX sets data-label on each <td> (see PayoutRequests.jsx edits). */
  .payout-requests-page .payout-table td[data-label]::before {
    content: attr(data-label);
    flex-shrink: 0;
    width: 90px;
    min-width: 90px;
    font-size: 0.7rem;
    font-weight: 600;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding-top: 0.125rem;
    line-height: 1.4;
  }

  /* Actions cell: no label, just the row of buttons */
  .payout-requests-page .payout-table .actions-cell {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding-top: 0.25rem;
    margin-top: 0.25rem;
    border-top: 1px solid var(--border-color);
  }

  .payout-requests-page .payout-table .actions-cell::before {
    display: none;
  }

  /* Ensure View/Profile buttons are tappable */
  .payout-requests-page .btn-view {
    min-height: 44px;
    flex: 1 1;
    justify-content: center;
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
  }

  /* Row action buttons (current .pro-table markup): 44px touch targets */
  .payout-requests-page .pro-table .row-actions .ent-btn--xs {
    min-height: 44px;
    height: auto;
    padding: 0.5rem 0.875rem;
  }

  .payout-requests-page .pro-table .row-actions .row-kebab {
    width: 44px;
    height: 44px;
  }

  /* ---- Empty / loading states ---- */
  .payout-requests-page .loading-container,
  .payout-requests-page .empty-state {
    padding: 2rem 1rem;
  }

  /* ---- Pagination ---- */
  .payout-requests-page .pagination-container {
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    padding: 0.875rem 0;
  }

  .payout-requests-page .pagination-info {
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.8rem;
    text-align: center;
  }

  .payout-requests-page .page-size-select {
    min-height: 44px;
  }

  .payout-requests-page .pagination-btn,
  .payout-requests-page .page-number {
    width: 44px;
    height: 44px;
    min-width: 44px;
  }

  /* ---- Right-side detail drawer -> full-width bottom sheet on mobile ---- */
  .payout-requests-page .request-detail-drawer {
    top: auto;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    height: 90vh;
    max-height: 90vh;
    border-radius: 16px 16px 0 0;
    animation: slideUpDrawer 0.3s ease-out;
    padding-bottom: env(safe-area-inset-bottom, 0);
  }

  @keyframes slideUpDrawer {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }

  .payout-requests-page .drawer-content {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Drawer header: make close button a full-width drag handle / back row */
  .payout-requests-page .drawer-header {
    padding: 0.875rem 1rem;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  /* Pull handle visual affordance at top of drawer */
  .payout-requests-page .drawer-header::before {
    content: '';
    display: block;
    width: 40px;
    height: 4px;
    background: var(--border-color);
    border-radius: 2px;
    margin: 0 auto 0.75rem auto;
  }

  .payout-requests-page .drawer-title-section h2 {
    font-size: 0.875rem;
    word-break: break-all;
  }

  /* Amount large: slightly smaller on very narrow screens */
  .payout-requests-page .amount-large {
    font-size: 1.4rem;
  }

  /* Detail info grid: keep single-column in drawer on mobile */
  .payout-requests-page .detail-info-grid {
    gap: 0.875rem;
  }

  /* Wallet connected card: stack on narrow */
  .payout-requests-page .wallet-connected {
    flex-direction: column;
    align-items: flex-start;
  }

  /* Action buttons in drawer: stack full-width */
  .payout-requests-page .action-buttons {
    flex-direction: column;
  }

  .payout-requests-page .btn-action {
    min-height: 48px;
    width: 100%;
  }

  /* ---- Reject modal -> bottom sheet ---- */
  .payout-requests-page .action-modal {
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    transform: none;
    width: 100%;
    max-width: 100%;
    border-radius: 16px 16px 0 0;
    padding-bottom: env(safe-area-inset-bottom, 0);
  }

  .payout-requests-page .modal-footer {
    flex-direction: column-reverse;
    gap: 0.5rem;
  }

  .payout-requests-page .btn-cancel,
  .payout-requests-page .btn-confirm {
    width: 100%;
    min-height: 48px;
    justify-content: center;
  }

  .payout-requests-page .form-group input,
  .payout-requests-page .form-group textarea {
    font-size: 1rem;              /* prevent iOS zoom on focus */
    min-height: 44px;
  }

  /* ---- Connect wallet button: full width in drawer ---- */
  .payout-requests-page .btn-connect-wallet {
    width: 100%;
    min-height: 48px;
    justify-content: center;
  }

  /* ---- Disconnect button: touch target ---- */
  .payout-requests-page .btn-disconnect {
    min-height: 44px;
    padding: 0.5rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/PayoutRequests.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF;;+EAE+E;AAC/E;EACE,qEAAqE;EACrE;IACE,UAAU;EACZ;;EAEA,mCAAmC;EACnC;IACE,qCAAqC;EACvC;;EAEA,mDAAmD;EACnD;IACE,WAAW;IACX,eAAe;EACjB;;EAEA,wDAAwD;EACxD;IACE,eAAe;EACjB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,0BAA0B;EAC1B;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,8BAA8B;EAC9B;IACE,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA,+EAA+E;EAC/E;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB,SAAS,YAAY;IAC1C,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa,iBAAiB,kBAAkB;EAClD;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;;EAEA,+BAA+B;EAC/B;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,eAAe,eAAe,mCAAmC;IACjE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe,eAAe,8BAA8B;EAC9D;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA,iCAAiC;EACjC;;;;;;IAME;;EAEF;IACE,mBAAmB,WAAW,mCAAmC;IACjE,YAAY;IACZ,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,aAAa,iBAAiB,6CAA6C;EAC7E;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,qCAAqC;IACrC,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,mBAAmB,WAAW,qCAAqC;EACrE;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;uEACqE;EACrE;IACE,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA,oDAAoD;EACpD;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,aAAa;EACf;;EAEA,6CAA6C;EAC7C;IACE,gBAAgB;IAChB,SAAO;IACP,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,uEAAuE;EACvE;IACE,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,qCAAqC;EACrC;;IAEE,kBAAkB;EACpB;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA,4EAA4E;EAC5E;IACE,SAAS;IACT,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,sCAAsC;IACtC,8CAA8C;EAChD;;EAEA;IACE,OAAO,2BAA2B,EAAE;IACpC,OAAO,wBAAwB,EAAE;EACnC;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,yEAAyE;EACzE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;;EAEA,mDAAmD;EACnD;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA,0DAA0D;EAC1D;IACE,iBAAiB;EACnB;;EAEA,6DAA6D;EAC7D;IACE,aAAa;EACf;;EAEA,2CAA2C;EAC3C;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,+CAA+C;EAC/C;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA,2CAA2C;EAC3C;IACE,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,eAAe;IACf,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,8CAA8C;EAChD;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;;IAEE,eAAe,eAAe,8BAA8B;IAC5D,gBAAgB;EAClB;;EAEA,0DAA0D;EAC1D;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,8CAA8C;EAC9C;IACE,gBAAgB;IAChB,oBAAoB;EACtB;AACF","sourcesContent":["/*\n * Responsive overrides for PayoutRequests.jsx (P0 — Admin payout approvals).\n * Loaded AFTER index.css so equal-specificity rules here win by source order.\n *\n * Breakpoints (single source of truth, matching CLAUDE.md):\n *   mobile  : <=576px\n *   tablet  : 577–991px\n *   laptop  : 992–1280px\n *   desktop : >=1281px\n *\n * Desktop appearance is intentionally unchanged. All overrides live inside\n * max-width media queries so they do not touch desktop rendering.\n */\n\n/* ==========================================================================\n   Tablet (<=991px): mild layout adjustments\n   ========================================================================== */\n@media (max-width: 991px) {\n  /* Give the page breathing room when the left sidebar is off-canvas */\n  .payout-requests-page {\n    padding: 0;\n  }\n\n  /* Stats: 2-column grid on tablet */\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  /* Right-side detail drawer: full width on tablet */\n  .request-detail-drawer {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  /* Toolbar: allow wrapping so sort button doesn't clip */\n  .table-toolbar {\n    flex-wrap: wrap;\n  }\n}\n\n/* ==========================================================================\n   Mobile (<=576px): full app-like treatment\n   ========================================================================== */\n@media (max-width: 576px) {\n  /* ---- Page header ---- */\n  .payout-requests-page .page-header {\n    margin-bottom: 1rem;\n  }\n\n  .payout-requests-page .page-header h1 {\n    font-size: 1.25rem;\n  }\n\n  /* ---- Gas tank banner ---- */\n  .payout-requests-page .gas-tank-banner {\n    font-size: 0.8rem;\n    padding: 0.625rem 0.75rem;\n    flex-wrap: wrap;\n  }\n\n  /* ---- Stats grid: single column ---- */\n  .payout-requests-page .stats-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.75rem;\n  }\n\n  .payout-requests-page .stat-card {\n    padding: 1rem;\n  }\n\n  .payout-requests-page .stat-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .payout-requests-page .stat-value {\n    font-size: 1.25rem;\n  }\n\n  /* ---- Status tabs: horizontally scrollable so they don't wrap/overflow ---- */\n  .payout-requests-page .status-tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;        /* Firefox */\n    flex-wrap: nowrap;\n    padding-bottom: 0;\n    gap: 0.25rem;\n  }\n\n  .payout-requests-page .status-tabs::-webkit-scrollbar {\n    display: none;                /* Chrome/Safari */\n  }\n\n  .payout-requests-page .status-tab {\n    padding: 0.75rem 0.875rem;\n    min-height: 44px;\n    flex-shrink: 0;\n  }\n\n  /* ---- Search + toolbar ---- */\n  .payout-requests-page .table-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.625rem;\n  }\n\n  .payout-requests-page .search-box {\n    max-width: none;              /* override the 400px desktop cap */\n    width: 100%;\n  }\n\n  .payout-requests-page .search-box input {\n    min-height: 44px;\n    font-size: 1rem;              /* prevent iOS zoom on focus */\n  }\n\n  .payout-requests-page .toolbar-actions {\n    justify-content: flex-end;\n  }\n\n  .payout-requests-page .btn-toolbar {\n    min-height: 44px;\n    padding: 0.625rem 1rem;\n  }\n\n  .payout-requests-page .btn-clear-filters {\n    min-height: 44px;\n    padding: 0.625rem 0.75rem;\n  }\n\n  /* ---- Table -> card view ---- */\n  /*\n   * The table is hidden and each <tr> is rendered as a card.\n   * Card layout uses CSS to show label/value pairs by targeting data-label\n   * attributes on <td> elements (added via JSX className approach below).\n   * We instead use a card-per-row approach by hiding thead and making\n   * each td a block with a pseudo-element label pulled from its class.\n   */\n\n  .payout-requests-page .payout-table-container {\n    overflow-x: visible;          /* no horizontal scroll on mobile */\n    border: none;\n    background: transparent;\n    padding: 0;\n  }\n\n  .payout-requests-page .payout-table {\n    display: block;\n    table-layout: auto;\n    border-collapse: collapse;\n  }\n\n  .payout-requests-page .payout-table thead {\n    display: none;                /* hide column headers; labels shown in CSS */\n  }\n\n  .payout-requests-page .payout-table tbody {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .payout-requests-page .payout-table tr {\n    display: flex;\n    flex-direction: column;\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 12px;\n    padding: 0.875rem 1rem;\n    gap: 0.5rem;\n    border-bottom: none;          /* override inline tr border-bottom */\n  }\n\n  .payout-requests-page .payout-table td {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    padding: 0;\n    font-size: 0.875rem;\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  /* Label prefix rendered via ::before using data-label attribute.\n     JSX sets data-label on each <td> (see PayoutRequests.jsx edits). */\n  .payout-requests-page .payout-table td[data-label]::before {\n    content: attr(data-label);\n    flex-shrink: 0;\n    width: 90px;\n    min-width: 90px;\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    padding-top: 0.125rem;\n    line-height: 1.4;\n  }\n\n  /* Actions cell: no label, just the row of buttons */\n  .payout-requests-page .payout-table .actions-cell {\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    padding-top: 0.25rem;\n    margin-top: 0.25rem;\n    border-top: 1px solid var(--border-color);\n  }\n\n  .payout-requests-page .payout-table .actions-cell::before {\n    display: none;\n  }\n\n  /* Ensure View/Profile buttons are tappable */\n  .payout-requests-page .btn-view {\n    min-height: 44px;\n    flex: 1;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    padding: 0.5rem 0.75rem;\n  }\n\n  /* Row action buttons (current .pro-table markup): 44px touch targets */\n  .payout-requests-page .pro-table .row-actions .ent-btn--xs {\n    min-height: 44px;\n    height: auto;\n    padding: 0.5rem 0.875rem;\n  }\n\n  .payout-requests-page .pro-table .row-actions .row-kebab {\n    width: 44px;\n    height: 44px;\n  }\n\n  /* ---- Empty / loading states ---- */\n  .payout-requests-page .loading-container,\n  .payout-requests-page .empty-state {\n    padding: 2rem 1rem;\n  }\n\n  /* ---- Pagination ---- */\n  .payout-requests-page .pagination-container {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.875rem 0;\n  }\n\n  .payout-requests-page .pagination-info {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.8rem;\n    text-align: center;\n  }\n\n  .payout-requests-page .page-size-select {\n    min-height: 44px;\n  }\n\n  .payout-requests-page .pagination-btn,\n  .payout-requests-page .page-number {\n    width: 44px;\n    height: 44px;\n    min-width: 44px;\n  }\n\n  /* ---- Right-side detail drawer -> full-width bottom sheet on mobile ---- */\n  .payout-requests-page .request-detail-drawer {\n    top: auto;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    max-width: 100%;\n    height: 90vh;\n    max-height: 90vh;\n    border-radius: 16px 16px 0 0;\n    animation: slideUpDrawer 0.3s ease-out;\n    padding-bottom: env(safe-area-inset-bottom, 0);\n  }\n\n  @keyframes slideUpDrawer {\n    from { transform: translateY(100%); }\n    to   { transform: translateY(0); }\n  }\n\n  .payout-requests-page .drawer-content {\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Drawer header: make close button a full-width drag handle / back row */\n  .payout-requests-page .drawer-header {\n    padding: 0.875rem 1rem;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n\n  /* Pull handle visual affordance at top of drawer */\n  .payout-requests-page .drawer-header::before {\n    content: '';\n    display: block;\n    width: 40px;\n    height: 4px;\n    background: var(--border-color);\n    border-radius: 2px;\n    margin: 0 auto 0.75rem auto;\n  }\n\n  .payout-requests-page .drawer-title-section h2 {\n    font-size: 0.875rem;\n    word-break: break-all;\n  }\n\n  /* Amount large: slightly smaller on very narrow screens */\n  .payout-requests-page .amount-large {\n    font-size: 1.4rem;\n  }\n\n  /* Detail info grid: keep single-column in drawer on mobile */\n  .payout-requests-page .detail-info-grid {\n    gap: 0.875rem;\n  }\n\n  /* Wallet connected card: stack on narrow */\n  .payout-requests-page .wallet-connected {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  /* Action buttons in drawer: stack full-width */\n  .payout-requests-page .action-buttons {\n    flex-direction: column;\n  }\n\n  .payout-requests-page .btn-action {\n    min-height: 48px;\n    width: 100%;\n  }\n\n  /* ---- Reject modal -> bottom sheet ---- */\n  .payout-requests-page .action-modal {\n    top: auto;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    transform: none;\n    width: 100%;\n    max-width: 100%;\n    border-radius: 16px 16px 0 0;\n    padding-bottom: env(safe-area-inset-bottom, 0);\n  }\n\n  .payout-requests-page .modal-footer {\n    flex-direction: column-reverse;\n    gap: 0.5rem;\n  }\n\n  .payout-requests-page .btn-cancel,\n  .payout-requests-page .btn-confirm {\n    width: 100%;\n    min-height: 48px;\n    justify-content: center;\n  }\n\n  .payout-requests-page .form-group input,\n  .payout-requests-page .form-group textarea {\n    font-size: 1rem;              /* prevent iOS zoom on focus */\n    min-height: 44px;\n  }\n\n  /* ---- Connect wallet button: full width in drawer ---- */\n  .payout-requests-page .btn-connect-wallet {\n    width: 100%;\n    min-height: 48px;\n    justify-content: center;\n  }\n\n  /* ---- Disconnect button: touch target ---- */\n  .payout-requests-page .btn-disconnect {\n    min-height: 44px;\n    padding: 0.5rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
